import classNames from 'classnames';
import PropTypes from 'prop-types';
import { useState } from 'react';
import DropdownItem from './DropdownItem';

const convertSavedSearches = savedSearches => Object.keys(savedSearches ?? {}).map(
    (key) => ({
        searchText: savedSearches[key].searchLabel,
        url: savedSearches[key].searchQuery,
    })
);

const RecentSavedTabs = ({
  recentSearches,
  savedSearches,
  handleSelect,
  isDrugIndex,
  highlightText,
  keyword,
  resultStyle,
}) => {
  const [selectedTab, setSelectedTab] = useState(0);

  const currentResults =
    selectedTab === 0
      ? recentSearches?.combinedSearches
      : convertSavedSearches(savedSearches);

  const recentOrSavedResults = Array.isArray(currentResults)
    ? currentResults.slice(0, 6)
    : [];

  return (
    <div className={resultStyle.tabs}>
      <button
        className={classNames({ [resultStyle.active]: selectedTab === 0 })}
        onClick={() => setSelectedTab(0)}
      >
        Recent
      </button>
      <button
        className={classNames({ [resultStyle.active]: selectedTab === 1 })}
        onClick={() => setSelectedTab(1)}
      >
        Saved
      </button>
      {recentOrSavedResults.length > 0 ? (
        recentOrSavedResults.map((item, index) => (
          <DropdownItem
            key={index}
            item={item}
            index={index}
            handleSelect={handleSelect}
            isDrugIndex={isDrugIndex}
            highlightText={highlightText}
            keyword={keyword}
            resultStyle={resultStyle}
          />
        ))
      ) : (
        <div className={resultStyle.noResults}>No results found</div>
      )}
    </div>
  );
};

RecentSavedTabs.propTypes = {
  recentSearches: PropTypes.object,
  savedSearches: PropTypes.object,
  handleSelect: PropTypes.func.isRequired,
  isDrugIndex: PropTypes.bool,
  highlightText: PropTypes.func.isRequired,
  keyword: PropTypes.string,
  resultStyle: PropTypes.object.isRequired,
};

export default RecentSavedTabs;
